import { createSlice } from "@reduxjs/toolkit";

export const sleepSlice = createSlice({
    name: "sleep",
    initialState: {
        cycles: []
    },
    reducers: {
        add_cycles: (state, action) => { state.cycles = [...action.payload] },
    }
}) // slice criada

export const { add_cycles } = sleepSlice.actions; //actions

export default sleepSlice.reducer // reducer
